import React from 'react';
import PropTypes from 'prop-types';
import { Typography, TableHead, TableBody, TableContainer, TableRow } from '@mui/material';
import { StyledTable, StyledTableHeaderCell } from './TipsTable.styles';
import TipsListEntry from '../TipsListEntry';

const TipsTable = ({ employees, lastPaymentData, handleOpenDrawer, isLoadingPaymentData }) => {
  return (
    <TableContainer>
      <StyledTable>
        <TableHead>
          <TableRow>
            <StyledTableHeaderCell>
              <Typography variant="h6GrayUppercase">All People</Typography>
            </StyledTableHeaderCell>
            <StyledTableHeaderCell>
              <Typography variant="h6GrayUppercase">Tips Owed</Typography>
            </StyledTableHeaderCell>
            <StyledTableHeaderCell>
              <Typography variant="h6GrayUppercase">Status</Typography>
            </StyledTableHeaderCell>
            <StyledTableHeaderCell>
              <Typography variant="h6GrayUppercase">Last Payment</Typography>
            </StyledTableHeaderCell>
            <StyledTableHeaderCell>
              <Typography variant="h6GrayUppercase">Paid By</Typography>
            </StyledTableHeaderCell>
            <StyledTableHeaderCell>
              <Typography variant="h6GrayUppercase">Payment Method</Typography>
            </StyledTableHeaderCell>
            <StyledTableHeaderCell>
              <Typography variant="h6GrayUppercase">Actions</Typography>
            </StyledTableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {employees.map((employee) => {
            const paymentData = lastPaymentData[employee.id] || {};
            return (
              <TipsListEntry
                key={employee.eid || employee.id}
                employee={employee}
                handleOpenDrawer={handleOpenDrawer}
                lastPaymentDate={paymentData.date || null}
                paidByName={paymentData.paidByName || null}
                paymentMethod={paymentData.paymentMethod || null}
                isLoadingPaymentData={isLoadingPaymentData}
              />
            );
          })}
        </TableBody>
      </StyledTable>
    </TableContainer>
  );
};

TipsTable.propTypes = {
  employees: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      eid: PropTypes.string,
      displayName: PropTypes.string,
      tipsOwed: PropTypes.number,
    })
  ).isRequired,
  lastPaymentData: PropTypes.object.isRequired,
  handleOpenDrawer: PropTypes.func.isRequired,
  isLoadingPaymentData: PropTypes.bool.isRequired,
};

export default TipsTable;
